import api from "../../api";

class BackendToolsAPI {
    static all() {
        return api.get("/backend/tools");
    }

    static update(payload = []) {
        return api.patch(`/backend/tools`, payload);
    }
}

export default BackendToolsAPI;
